import React from 'react';
import styles from './TierBadge.module.css';
import { TierType } from '../storeTieringTypes';

interface TierBadgeProps {
  tier: TierType;
}

export const TierBadge: React.FC<TierBadgeProps> = ({ tier }) => {
  return (
    <span className={`${styles.badge} ${styles[`tier${tier}`]}`}>
      {tier}
    </span>
  );
};
